import { lighten } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
    root: {
        width: '100%',
    },
    table: {
        // minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    tableCellEdit: {
        borderBottom: 'none'
    },
  
});

export const tablecellStyles = theme => ({
    alignCenter: {
        textAlign: 'center',
    },
    alignLeft: {
        textAlign: 'left',
    },
    smallWidth: {
        width: '2%'
    },
    normal: {

    },
    statusHead: {
        width: '13%',
        textAlign: 'center',
    }
});

export const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

export const addCustomerStyle = theme => ({
  titlePayment: {
    textAlign: 'center',
    fontSize: '1.6rem',
    fontWeight: '500'
  },
  TextField: {
    marginTop: '1.5rem'
  }, 
  DialogActions: {
    padding: '1.5rem'
  }
})